import type { HTMLAttributes } from "react";

export default function QIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.36985 7.57955H6.04031L7.02965 8.86222L7.73562 9.69744L9.43093 11.875H7.64116L6.48775 10.4134L5.99556 9.71733L4.36985 7.57955ZM9.67454 5.90909C9.67454 7.00616 9.46905 7.94579 9.05806 8.72798C8.65039 9.50687 8.09357 10.1035 7.38761 10.5178C6.68496 10.9321 5.88784 11.1392 4.99627 11.1392C4.1047 11.1392 3.30593 10.9321 2.59996 10.5178C1.89731 10.1001 1.34049 9.50189 0.92951 8.72301C0.52184 7.94081 0.318004 7.00284 0.318004 5.90909C0.318004 4.81203 0.52184 3.87405 0.92951 3.09517C1.34049 2.31297 1.89731 1.71473 2.59996 1.30043C3.30593 0.886126 4.1047 0.678977 4.99627 0.678977C5.88784 0.678977 6.68496 0.886126 7.38761 1.30043C8.09357 1.71473 8.65039 2.31297 9.05806 3.09517C9.46905 3.87405 9.67454 4.81203 9.67454 5.90909ZM7.82014 5.90909C7.82014 5.13684 7.69916 4.48556 7.45721 3.95526C7.21857 3.42164 6.88713 3.01894 6.46289 2.74716C6.03865 2.47206 5.54978 2.33452 4.99627 2.33452C4.44277 2.33452 3.95389 2.47206 3.52965 2.74716C3.10541 3.01894 2.77231 3.42164 2.53036 3.95526C2.29173 4.48556 2.17241 5.13684 2.17241 5.90909C2.17241 6.68134 2.29173 7.33428 2.53036 7.8679C2.77231 8.3982 3.10541 8.8009 3.52965 9.07599C3.95389 9.34777 4.44277 9.48366 4.99627 9.48366C5.54978 9.48366 6.03865 9.34777 6.46289 9.07599C6.88713 8.8009 7.21857 8.3982 7.45721 7.8679C7.69916 7.33428 7.82014 6.68134 7.82014 5.90909Z"
        fill="currentColor"
      />
    </svg>
  );
}
